/* eslint-disable max-statements */
/*global angular*/

const { sanitizeContext, getFields } = require('../bib/search/bibSearchHelper');

module.exports = ['$scope', '$state', '$stateParams', '$location', 'settings', 'bibContentManager', '$notification', 'curriculumManager', 'ageRangeManager', function ($scope, $state, $stateParams, $location, settings, bibContentManager, $notification, curriculumManager, ageRangeManager) {
  'use strict';

  $scope.results = [];
  $scope.searching = true;

  //result configuration
  $scope.limit = 8;
  $scope.currentOffset = parseInt($stateParams.offset || 0);
  $scope.q = $stateParams.q;
  $scope.selectedTypes = {};

  $scope.typeToLabelMap = new Map();
  $scope.typeToLabelMap.set('VISION_TEXT', 'Concept');
  $scope.typeToLabelMap.set('ZILL_CONCEPT_PAGE_SECTION', 'Concept');
  $scope.typeToLabelMap.set('ZILL_CURRICULUM_CONTENT', 'leerinhoud');
  $scope.typeToLabelMap.set('CURRICULUM_ZILL_GENERIC_GOAL', 'generiek doel');
  $scope.typeToLabelMap.set('CURRICULUM_ZILL_DEVELOPMENT_THEME', 'ontwikkelthema');
  $scope.typeToLabelMap.set('CURRICULUM_ZILL_DEVELOPMENT_FIELD', 'ontwikkelveld');
  $scope.typeToLabelMap.set('ZILL_ILLUSTRATION', 'Illustratie');
  $scope.typeToLabelMap.set('ZILL_PRACTICAL_EXAMPLE', 'Praktijkvoorbeeld');
  $scope.typeToLabelMap.set('ZILL_TERM', 'Begrip');

  $scope.conceptMap = new Map();
  $scope.conceptMap.set(settings.concept.krachtlijnen, 'krachtlijnen');
  $scope.conceptMap.set(settings.concept.leeruitkomst, 'leeruitkomst');
  $scope.conceptMap.set(settings.concept.ordeningskader, 'ordeningskader');

  if ($stateParams.types) {
    const resultTypes = $stateParams.types.split(',');
    resultTypes.forEach(searchType => {
      $scope.selectedTypes[searchType] = true;
    });
  }

  // FYI: data types used with previous api (https://vsko-search-api-test.herokuapp.com/)
  // are commented out, just to have a reference in case of bug or maintenance.
  const searchOptions = {
    concept: [
      // 'VISION_TEXT_SECTION',
      // 'VISION_TEXT_PARAGRAPH'
      'ZILL_CONCEPT_PAGE_SECTION'
    ],
    leerinhoud: [
      // 'CURRICULUM_ZILL_LEERLIJN_CLUSTER',
      // 'CURRICULUM_ZILL_DEVELOPMENT_CONTENT',
      // 'CURRICULUM_ZILL_DEVELOPMENT_FIELD',
      // 'CURRICULUM_ZILL_DEVELOPMENT_THEME',
      // 'CURRICULUM_ZILL_GENERIC_GOAL'
      'ZILL_CURRICULUM_CONTENT'
    ],
    bib: [
      // 'ODET_GOAL',
      // 'ATTACHMENT',
      // 'ZILL_ILLUSTRATION', // Type is been removed from general search, but it's still a valid type for search-api.
      // 'PRACTICAL_EXAMPLE',
      // 'PRACTICAL_EXAMPLE_SECTION',
      // 'PRACTICAL_EXAMPLE_PARAGRAPH',
      // 'TERM'
      'ZILL_PRACTICAL_EXAMPLE',
      'ZILL_TERM'
    ]
  };

  function getGoals(result, searchOption) {

    const goals = [];

    if (searchOption === 'leerinhoud' && result.ancestors) {
      result.ancestors.forEach(ancestor => {
        if (ancestor.type === 'CURRICULUM_ZILL_GENERIC_GOAL') {
          const extendedContent = curriculumManager.getByHrefNoPromise(ancestor.href);
          goals.push(extendedContent);
        }
      });
    }

    if (searchOption === 'bib' && result.referencedGenericGoals) {
      result.referencedGenericGoals.forEach(goal => {
        const extendedContent = curriculumManager.getByHrefNoPromise(goal.href);

        if (extendedContent && extendedContent.type === 'CURRICULUM_ZILL_GENERIC_GOAL') {
          goals.push(extendedContent);
        }
      });
    }

    return goals;
  }

  function getTitle(result, goals) {

    if (['ZILL_CURRICULUM_CONTENT', 'CURRICULUM_ZILL_LEERLIJN', 'CURRICULUM_ZILL_LEERLIJN_CLUSTER'].includes(result.$$meta.type)) {
      if(goals && goals.length > 0) {
        return goals[0].title;
      }
      return '';
    }

    if (result.title) {
      return result.title;
    } else if (result.ancestors && result.ancestors.length > 0) {
      return result.ancestors[result.ancestors.length - 1].label;
    }

    return;
  }

  function getCode(result, goals) {
    if (['ZILL_CURRICULUM_CONTENT', 'ZILL_CURRICULUM_CONTENT', 'ZILL_PRACTICAL_EXAMPLE'].includes(result.type) && !result.practicalExample && goals && goals.length > 0) {
      return goals[0].code;
    }

    return result.code;
  }

  function getColor(result, searchOption, goals) {
    if (searchOption === 'leerinhoud') {
      return result.color;
    } else if (searchOption === 'bib') {
      if (goals && goals.length > 0) {
        return goals[0].theme.field.color;
      }
    }

    return;
  }

  function getAgeRange(result) {
    if (result.$$meta.type === 'CURRICULUM_ZILL_LEERLIJN_CLUSTER') {
      return ageRangeManager.ageRangeToString(result.startage, result.endage);
    }
    return;
  }

  function getDevelopmentSteps(result) {
    if (result.type === 'ZILL_CURRICULUM_CONTENT') {
      if(result.$$context && result.$$context.developmentContent) {
        return result.$$context.developmentContent;
      }
    }
    return [];
  }

  function getDescription(result) {
    if (result.$$context && result.$$context.description) {
      return sanitizeContext(result.$$context.description);
    } else if(result.description) {
      return sanitizeContext(result.description);
    }
    return '';
  }

  function getReferencedGenericGoals(result) {
    let goalsWithData = [];

    if (result.type === 'ZILL_PRACTICAL_EXAMPLE' && result.$$context && result.$$context.referencedGenericGoals) {
      goalsWithData = result.$$context.referencedGenericGoals.map(goal => {
        if(goal.illustration.title) {
          goal.illustration.title = sanitizeContext(goal.illustration.title);
        }
        return goal;
      });
    }

    return goalsWithData;
  }

  function addContainerKeyTo(result, type, containerType) {
    if (result.$$meta.type === type) {
      const invertedAncestors = result.ancestors.slice().reverse();
      const container = invertedAncestors.find(ancestor => ancestor.type === containerType);
      if (container) {
        return 'containerKey=' + container.href.split('/').pop();
      }
    }
    return '';
  }

  function addContentKeyFor(result, type) {
    if (result.$$meta.type === type) {
      return 'contentKey=' + result.key;
    }
    return '';
  }

  function getZillHrefParameters(result) {
    const parameters = [];
    parameters.push(addContainerKeyTo(result, 'CURRICULUM_ZILL_DEVELOPMENT_CONTENT', 'CURRICULUM_ZILL_DEVELOPMENT_CONTENT'));
    parameters.push(addContainerKeyTo(result, 'CURRICULUM_ZILL_LEERLIJN_CLUSTER', 'CURRICULUM_ZILL_DEVELOPMENT_CONTENT'));
    parameters.push(addContentKeyFor(result, 'CURRICULUM_ZILL_LEERLIJN_CLUSTER'));
    const hrefParameters = parameters.filter(parameter => parameter !== '');
    return hrefParameters.reduce((previousValue, parameterValue, index) => {
      return index === 0 ? '?' + previousValue + parameterValue : previousValue + '&' + parameterValue;
    }, '');
  }

  function getZillGoalHref(goal, result) {
    const leerinhoud = '/leerinhoud/';
    if (goal.theme) {
      let href = [leerinhoud, goal.theme.field.identifiers[0], '/', goal.theme.identifiers[0], '/', goal.identifiers[0]].join('');
      return href + getZillHrefParameters(result);
    }
    return leerinhoud;
  }

  function getDefaultConceptHref(result, navPath) {
    let lastNavigableAncestorPos;
    if(navPath[1]) {
      lastNavigableAncestorPos = Math.min(navPath[1].href.split('/').pop() === 'krachtlijnen' ? 3 : 2, result.ancestors.length);
    }
    return lastNavigableAncestorPos ? navPath[1].href + '/' + result.ancestors[lastNavigableAncestorPos - 1].href.split('/').pop() : '';
  }

  function getZillHref(result, searchOption, navPath, goals) {
    let href = '';

    if (!navPath.length) {
      return href;
    }

    if (searchOption === 'concept') {
      if (result.type === 'ZILL_CONCEPT_PAGE_SECTION') {
        if ($scope.conceptMap.has(result.$$meta.permalink)) {
          href = navPath[0].href + '/' + $scope.conceptMap.get(result.$$meta.permalink);
        } else if(navPath[1]) {
          href = navPath[1].href + '/' + result.key;
        } else {
          href = getDefaultConceptHref(result, navPath);
        }
      }

    } else if (searchOption === 'leerinhoud') {
      const curriculumContent = curriculumManager.getByHrefNoPromise(result.$$meta.permalink);
      if (!curriculumContent.identifiers) {
        href = getZillGoalHref(goals[0], result);
      } else {
        href = navPath[navPath.length - 1].href + '/' + (curriculumContent ? curriculumContent.identifiers[0] : '');
      }
    } else if (searchOption === 'bib') {
      if (result.practicalExample && result.practicalExample.key) {
        href = navPath[0].href + '/' + result.practicalExample.key;
      } else if (['PRACTICAL_EXAMPLE_SECTION', 'PRACTICAL_EXAMPLE_PARAGRAPH'].includes(result.$$meta.type)) {
        href = navPath[0].href + '/' + result.ancestors[0].href.split('/').pop();
      } else if (result.$$meta.type === 'ATTACHMENT') {
        let ancestorsInReverseOrder = result.ancestors.reverse();
        let parent = ancestorsInReverseOrder.find((ancestor) => ancestor.type === 'SECTION');
        if (!parent) {
          //if the attachment is not linked to a section then we point to the whole document where that attachment belongs
          parent = ancestorsInReverseOrder.find((ancestor) => ancestor.type === 'STRUCTURED_DOCUMENT');
        }
        if (parent) {
          href = navPath[0].href + '/' + parent.href.split('/')[2];
        } else {
          href = navPath[0].href;
        }
      } else if (result.type === 'ZILL_TERM') {
        href = navPath[0].href + '/begrippen/' + result.key;
      } else if (result.$$meta.type === 'ODET_GOAL') {

        /*
        https://zill.katholiekonderwijs.vlaanderen/#!/bib/concordanties
            ?way=1
            &type=4e854b90-7f65-4f96-9b40-e161eefaa87a
            &leergebied=2919fd9c-490d-49af-97ec-ab7ff92e5c72
            &domain=1836fe91-0b94-45c1-94b7-66fa66b6b316
            &odetGoal=9c5f246f-4fb1-4d29-bd20-be560a149b45
        */

        href = navPath[0].href + '/concordanties?way=1';

        let odetLevel = result.ancestors.find((ancestor) => ancestor.type === 'CURRICULUM_ODET_LEVEL');
        if (odetLevel) {
          href = href + '&type=' + odetLevel.href.split('/')[2];
        }

        let odetLeergebiedIndex = result.ancestors.findIndex((ancestor) => ancestor.type === 'CURRICULUM_ODET_LEERGEBIED');
        if (odetLeergebiedIndex >= 0) {
          href = href + '&leergebied=' + result.ancestors[odetLeergebiedIndex].href.split('/')[2];

          if (result.ancestors[odetLeergebiedIndex + 1] && result.ancestors[odetLeergebiedIndex + 1].type === 'CURRICULUM_ODET_SUBSECTION') {
            href = href + '&domain=' + result.ancestors[odetLeergebiedIndex + 1].href.split('/')[2];
          }
        }
        href = href + '&odetGoal=' + result.key;

      } else {
        href = navPath[0].href + '/' + result.key;
      }
    } else if(result.$$meta.type === 'VISION_TEXT') {
      if ($scope.conceptMap.has(result.$$meta.permalink)) {
        href = navPath[0].href + '/' + $scope.conceptMap.get(result.$$meta.permalink);
      }
    }

    return href;
  }

  function getNavPathFromConceptResult(result, searchOption) {
    const path = [{
      label: searchOption,
      href: '/' + searchOption
    }];

    const ancestors = result.ancestors ? result.ancestors.map(ancestor => Object.assign({}, ancestor)) : [];
    let level1;

    Object.keys(settings[searchOption]).forEach((zillTab) => {
      const level1ancestor = ancestors.find(ancestor => settings[searchOption][zillTab] === ancestor.href);
      if(level1ancestor) {
        level1 = zillTab;
      }
    });

    if (level1) {
      path.push({
        label: level1,
        href: [path[0].href, level1].join('/')
      });

      ancestors.reverse();

      for (let i = 1; i < ancestors.length; i++) {
        path.push({
          label: ancestors[i].title,
          href: [path[1].href, ancestors[i].href.split('/').pop()].join('/')
        });
      }
    }

    return path;
  }

  function getNavPathFromLeerinhoudResult(result, searchOption) {

    const path = [{
      label: searchOption,
      href: '/' + searchOption
    }];

    let ancestors = [];

    for (let ancestor of result.ancestors) {
      if (['CURRICULUM_ZILL', 'CURRICULUM_ZILL_CLUSTER'].includes(ancestor.type)) {
        continue;
      }

      ancestors.push(Object.assign({}, curriculumManager.getByHrefNoPromise(ancestor.href), ancestor));
    }

    ancestors = ancestors.reverse();

    ancestors.forEach((ancestor) => {
      if (ancestor.identifiers && ancestor.type !== 'CURRICULUM_ZILL_GENERIC_GOAL') {
        path.push({
          label: ancestor.title,
          href: path[path.length - 1].href + '/' + ancestor.identifiers[0]
        });
      }
    });

    return path;
  }

  function getNavPathFromBibResult(result, searchOption) {

    let filterType;

    if (result.type === 'ZILL_PRACTICAL_EXAMPLE') {
      filterType = 'klaspraktijk';
    } else if (result.type === 'ZILL_TERM') {
      filterType = 'begrippen';
    }

    const path = [{
      label: searchOption,
      href: '/' + searchOption
    }];

    if (filterType) {
      path.push({
        label: filterType,
        href: path[0].href + '/' + filterType
      });
    }

    return path;
  }

  function getNavPathFromResult(result, searchOption) {
    let path = [];

    if (!result.ancestors && searchOption !== 'bib') {
      if (result.$$meta.type === 'VISION_TEXT') {
        path.push({
          label: 'concept',
          href: '/concept'
        });
      }
      return path;
    }

    if (searchOption === 'concept') {
      return getNavPathFromConceptResult(result, searchOption);
    }

    if (searchOption === 'leerinhoud') {
      return getNavPathFromLeerinhoudResult(result, searchOption);
    }

    if (searchOption === 'bib') {
      return getNavPathFromBibResult(result, searchOption);
    }

    return path;
  }

  function getLabel(type, contentType) {
    if (type === 'ZILL_CURRICULUM_CONTENT') {
      const labelForContentType = $scope.typeToLabelMap.get(contentType);
      if (labelForContentType) {
        return labelForContentType;
      }
    }
    if ($scope.typeToLabelMap.has(type)) {
      return $scope.typeToLabelMap.get(type);
    }
    return type;
  }

  function getContext(result) {
    if(!result.$$context) {
      return null;
    }

    return result.$$context;
  }

  /**
   * We handle here 2 kinds of paragraphs: the ones that are part of the search result context...
   * ... and the first paragraph that usually comes with a ZILL_CONCEPT_PAGE_SECTION result.
   * In any case, if the paragraphs are part of the search context, we sanitize them and return it.
   * Returning the first paragraph is a special case, as when we are handling search results...
   * ... whitout a search term (i.e.: /#!/zoeken?types=concept).
   */
  function getParagraphs(result) {
    const paragraphs = [];
    if (result.$$context && result.$$context.paragraphs) {
      result.$$context.paragraphs.forEach(paragraph => {
        const paragraphCopy = angular.copy(paragraph);
        paragraphCopy.text = '"' + sanitizeContext(paragraph.text) + '"';
        paragraphs.push(paragraphCopy);
      });
    } else if(result.firstParagraph) {
      paragraphs.push({
        text: result.firstParagraph
      });
    }
    return paragraphs;
  }

  function buildResultViewModel(results) {
    const count = results.count();
    let items = results.map(result => {
      const searchOption = Object.keys(searchOptions).find(zillTab => searchOptions[zillTab].includes(result.type));
      const navPath = getNavPathFromResult(result, searchOption);
      const goals = getGoals(result, searchOption);

      return {
        context: getContext(result),
        title: getTitle(result, goals),
        label: getLabel(result.type, result.contentType),
        code: getCode(result, goals),
        color: getColor(result, searchOption, goals),
        developmentSteps: getDevelopmentSteps(result),
        ageRange: getAgeRange(result),
        thumb: result.thumbnail ? settings.apisAndUrls.cachedApi + result.thumbnail : '',
        referencedGenericGoals: getReferencedGenericGoals(result),
        fields: getFields(result.referencedGenericGoals, curriculumManager),
        description: getDescription(result, goals),
        paragraphs: getParagraphs(result),
        href: getZillHref(result, searchOption, navPath, goals),
        navPath: navPath,
        type: result.type,
        key: result.key
      };
    });

    items.count = function () {
      return count;
    };

    return items;
  }

  $scope.search = function () {

    $scope.searching = true;

    const contentFilters = {
      limit: $scope.limit,
      offset: $scope.currentOffset,
      highlight: true
      //index: 'search-api-index-v27'
    };

    let types = [];

    Object.keys($scope.selectedTypes).forEach(selectedType => {
      if ($scope.selectedTypes[selectedType]) {
        types = [... new Set([... types, ...searchOptions[selectedType]])];
      }
    });

    if (types.length === 0) {
      contentFilters.useCase = 'ZILL_SEARCH';
      // When no type is selected, we search in all types except ZILL_ILLUSTRATION
      types = ['ZILL_CONCEPT_PAGE_SECTION', 'ZILL_CURRICULUM_CONTENT', 'ZILL_PRACTICAL_EXAMPLE', 'ZILL_TERM'];
    }

    bibContentManager.getContentUnder($scope.curr.$$meta.permalink, types, $scope.q, contentFilters).then(function (results) {
      $scope.searching = false;
      $scope.results = buildResultViewModel(results);

    }, function (error) {
      $notification.error(JSON.stringify(error));
      $scope.results = [];
    });
  };

  $scope.clear = function () {
    $scope.q = '';
    $scope.selectedTypes = {};
    $scope.currentOffset = null;
    $scope.results = [];
    $scope.searching = false;
    $scope.setState($scope.currentOffset);
  };

  $scope.setState = function (offset) {

    let params = {
      offset: offset,
      q: $scope.q
    };

    const resultTypes = Object.keys($scope.selectedTypes).filter(selectedResultType => $scope.selectedTypes[selectedResultType]);
    params.types = resultTypes.join(',');

    $state.go($state.current.name, params, { notify: false, location: true});
  };

  //When curriculum is loaded, update curr ect
  curriculumManager.getCurriculum().then(function (curr) {
    $scope.curr = curr;
    //if ($scope.q) {
    $scope.search($scope.currentOffset);
    //}
  }, function () {
    $notification.error();
    $scope.results = [];
  });

}];



// WEBPACK FOOTER //
// ./web/js/screen/search/searchController.js